<div class="position-relative h-100">
  <div class="side-bar">
    <div class="d-flex justify-content-between align-items-center pb-px-12">
      <mat-label class="fs-20 fw-700">{{ data.firstName }} {{ data.lastName }}</mat-label>
      <img (click)="dialogRef.close()" src="/assets/icons/close-modal-primary.svg"
           class="cursor-pointer"/>
    </div>

    <div class="mt-px-32">
      <app-text-separator text="Détails du collaborateur" [innerClass]="'my-px-24'"></app-text-separator>

      <div class="row">
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Civilité</div>
          <div class="fs-16 fw-4">{{ data.title || 'N/A' }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Fonction</div>
          <div class="fs-16 fw-4">{{ data.fonction || 'N/A' }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Prénom</div>
          <div class="fs-16 fw-4">{{ data.firstName || 'N/A' }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Nom</div>
          <div class="fs-16 fw-4">{{ data.lastName || 'N/A' }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Email</div>
          <div class="fs-16 fw-4">{{ data.email || data.mail || 'N/A' }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Téléphone</div>
          <div class="fs-16 fw-4">{{ data.phoneNumber || data.numTel || 'N/A' }}</div>
        </div>
      </div>

      <app-text-separator text="Accès" [innerClass]="'my-px-24'"></app-text-separator>
      <div class="row">
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Rôle</div>
          <div class="fs-16 fw-4">{{ data.roleLabel || 'N/A' }}<span *ngIf="data.mainAccount"> — dirigeant principal</span></div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Statut</div>
          <div class="fs-16 fw-4">
            {{ data.statusLabel || 'N/A' }}
            <span *ngIf="data.status === 'PENDING' && data.invitationExpired" class="required"> (invitation expirée)</span>
          </div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Invité le</div>
          <div class="fs-16 fw-4">{{ format(data.invitedAt) }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Activé le</div>
          <div class="fs-16 fw-4">{{ format(data.activatedAt) }}</div>
        </div>
        <div class="col-6 mb-px-16">
          <div class="fw-3 fs-13">Dernière connexion</div>
          <div class="fs-16 fw-4">{{ format(data.lastLoginAt) }}</div>
        </div>
      </div>

      <div class="mb-px-16" *ngIf="permissionLabels.length">
        <div class="fw-3 fs-13 mb-px-8">Droits accordés par ce rôle</div>
        <ul class="fs-14 ps-3 mb-0">
          <li *ngFor="let label of permissionLabels">{{ label }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
